import { Box, Grid, InputLabel, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { Rings } from "react-loader-spinner";
import useAxios from "../hooks/useAxios";
import { itemLookupApi } from "../apis/item-lookup";

const qualityColors: Record<string, string> = {
  white: "rgb(199, 215, 223)",
  blue: "rgb(100, 97, 255)",
  purple: "rgb(165, 58, 252)",
  gold: "rgb(240, 221, 53)",
  pink: "rgb(199, 119, 159)",
};

const gearSlotEmojis: Record<string, string> = {
  chest:  "🧥",
  eyes:   "🧐",
  face:   "🎭",
  feet:   "🧦",
  hands:  "🧤",
  head:   "🎩",
  legs:   "👖",
  neck:   "📿",
  seat:   "🪑",
  back:   "🎒",
  weapon: "🗡️",
};

export const ItemDetails = (inputVars) => {
  var ics = function (rawCoinValue, removeIRM) {
    var stringToDisplay = "$IRM ";
    if (removeIRM === true) {
      stringToDisplay = "";
    }

    var displayDecimalAsString = null;

    if (rawCoinValue > 1000000000000) {
      displayDecimalAsString = parseFloat(
        ((1.0 * rawCoinValue) / 1000000000000).toFixed(3)
      );
      return stringToDisplay + displayDecimalAsString + "t";
    }

    if (rawCoinValue > 1000000000) {
      displayDecimalAsString = parseFloat(
        ((1.0 * rawCoinValue) / 1000000000).toFixed(3)
      );
      return stringToDisplay + displayDecimalAsString + "b";
    }
    if (rawCoinValue > 1000000) {
      displayDecimalAsString = parseFloat(
        ((1.0 * rawCoinValue) / 1000000).toFixed(2)
      );
      return stringToDisplay + displayDecimalAsString + "m";
    }
    if (rawCoinValue > 10000) {
      displayDecimalAsString = parseFloat(
        ((1.0 * rawCoinValue) / 1000).toFixed(1)
      );
      return stringToDisplay + displayDecimalAsString + "k";
    }

    return stringToDisplay + rawCoinValue;
  };

  var vars = { ...inputVars.inputVars };

  const [data, error, loading, axiosFetch] = useAxios() as any;

  useEffect(() => {
    if (vars.name && vars.name !== "????????????") {
      axiosFetch({
        axiosInstance: itemLookupApi(vars.name),
        method: "get",
      });
    }
  }, [vars.name]);

  if (vars.name === "????????????") {
    return (
      <Box className="invBox">
        <Typography variant="body2" color="#aaaaaa">
          Unclaimed item
        </Typography>
      </Box>
    );
  }

  var apiData = data && !Array.isArray(data) && typeof data === "object"
    && data.name?.toLowerCase() === vars.name?.toLowerCase()
    ? data : null;
  var itemQuality: string | undefined = apiData?.quality;
  var nameColor = itemQuality ? qualityColors[itemQuality] : "#888888";

  var priceEachFormatted = vars.price != null ? ics(vars.price, true) : null;
  var priceTotalFormatted = vars.price != null && vars.quantity != null ? ics(vars.price * vars.quantity, true) : null;

  return (
    <Box className="invBox">
      <Grid
        display="flex"
        justifyContent={{ xs: "center", sm: "flex-start" }}
      >
        <img
          src={"./items/" + vars.name + ".png"}
          width="50px"
          height="50px"
          className="anIcon"
        />
        <Stack direction="column" spacing={0}>
          <Typography variant="h6" style={{ color: nameColor, whiteSpace: "nowrap" }}>
            {vars.name}
          </Typography>
          {vars.quantity != null && (
            <InputLabel>{"Quantity: " + vars.quantity}</InputLabel>
          )}
          {priceEachFormatted != null && (
            <Typography sx={{ fontSize: "0.6rem", color: "#666666" }}>{"Sell Ea: " + priceEachFormatted}</Typography>
          )}
          {priceTotalFormatted != null && (
            <Typography sx={{ fontSize: "0.6rem", color: "#666666" }}>{"Sell Total: " + priceTotalFormatted}</Typography>
          )}

          {loading && (
            <Rings height="40" width="40" radius="6" color="grey" ariaLabel="loading" />
          )}

          {apiData && (
            <>
              {apiData.description && (
                <Typography variant="body2" color="#888888" sx={{ maxWidth: "240px", wordBreak: "break-word", whiteSpace: "normal" }}>
                  {apiData.description}
                </Typography>
              )}
              {apiData.gearSlot && (
                <InputLabel>{"Equipt: " + (gearSlotEmojis[apiData.gearSlot] ?? apiData.gearSlot)}</InputLabel>
              )}

              {vars.price == null && apiData.price != null && (
                <InputLabel>{"Price: " + ics(apiData.price, true)}</InputLabel>
              )}
              {apiData.unsellable === true && (
                <Typography variant="caption" style={{ color: "#ff6666" }}>
                  Untradeable
                </Typography>
              )}
            </>
          )}
        </Stack>
      </Grid>
    </Box>
  );
};
